import React from 'react';
import styles from './settings-ui.module.css';

export interface SettingsListProps {
  children: React.ReactNode;
  emptyMessage?: string;
  className?: string;
}

/**
 * SettingsList - Connected list container (Linear style)
 * 
 * Creates 1px gaps between items with shared borders
 */
export const SettingsList: React.FC<SettingsListProps> = ({
  children,
  emptyMessage,
  className,
}) => {
  const hasChildren = React.Children.count(children) > 0;

  if (!hasChildren && emptyMessage) {
    return <div className={styles.listEmpty}>{emptyMessage}</div>;
  }

  return (
    <div className={`${styles.list} ${className || ''}`}>
      {children}
    </div>
  );
};

export interface SettingsListItemProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * SettingsListItem - Individual item in a connected list
 */
export const SettingsListItem: React.FC<SettingsListItemProps> = ({
  children,
  className,
}) => {
  return (
    <div className={`${styles.listItem} ${className || ''}`}>
      {children}
    </div>
  );
};

export default SettingsList;
